import { render, staticRenderFns } from "./4_finish.vue?vue&type=template&id=6378521c&"
import script from "./4_finish.vue?vue&type=script&lang=js&"
export * from "./4_finish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports